import { FilterDocumentFilters, FilterOptionKeys } from '@griply/types';

// Absent keys become explicit `null` so a persisted write clears stale slots.
export const pickFilterOptions = <K extends FilterOptionKeys>(
  source: Pick<FilterDocumentFilters, K> | null | undefined,
  keys: readonly K[],
): Pick<FilterDocumentFilters, K> =>
  Object.fromEntries(keys.map((key) => [key, source?.[key] ?? null])) as Pick<
    FilterDocumentFilters,
    K
  >;
